import {handleActions} from 'redux-actions'

export default function({
    ACTIVE_LICENSE_INFO = {}
}) {
    const initialState = ACTIVE_LICENSE_INFO || {
        daysToExpiration: -1,
        type: null,
        thereARenewal: false,
        violated: false,
        otherProductExpired: false,
        otherProductViolated: false,
        wasOtherProductEverIntegrated: false,
        userCounters: {
            allowedCount: 0,
            actualCount: 0
        },
        licenseManagerStatus: null
    }

    return handleActions({
        // empty for now, no need to update license state without page reload
    }, initialState)
}



// WEBPACK FOOTER //
// ./web/js/activeLicenseInfo/reducer.js